import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  fetchRepresentManualPath,
  PLATFORM_TYPE,
} from "../../util/platformNavigation";
import api from "../../api/api";
import { setSideMenuReducer } from "../../store/slice/sideMenuSlice";
import "./ManualPage.scss";
import ManualViewPage from "./ManualViewPage.jsx";

function ManualPage() {
  const manualType = useSelector((state) => state.manualTypeChecker.manualType);
  const platformType = useSelector(
    (state) => state.platformTypeChecker.platformType,
  );
  const initialOptions = {};
  const [pageData, setPageData] = useState(initialOptions);
  const [shortCutData, setShortCutData] = useState([]);
  const [requestFailed, setRequestFailed] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { name } = useParams();
  const hash = decodeURIComponent(window.location.hash)?.replace(/^#/, "");

  useEffect(() => {
    if (name === "no-index") {
      return () => {
        window.scrollTo(0, 0);
      };
    }
    const url = "/" + name;
    axios
      .get(api.manual.select, { params: { url: url } })
      .then((res) => {
        setPageData(res.data);
        setShortCutData(res.data.bookmark);
        dispatch(
          setSideMenuReducer({
            category: res.data.categoryId,
            product: res.data.productId,
            manual: res.data.id,
          }),
        );
        // if (res.data.display === "N") {
        //   navigate(""); // 에러페이지로 리다이렉트 고려
        // }
      })
      .catch((error) => {
        // if (error.response.status !== 404) {
        setRequestFailed(true);
        // }
      });
    return () => {
      window.scrollTo(0, 0);
    };
    // eslint-disable-next-line
  }, [name, manualType, platformType]);

  useEffect(() => {
    if (!requestFailed || name === "no-index" || !manualType) return;
    const redirectHome = async () => {
      const targetPlatformType =
        manualType === "g" && platformType === "kcp"
          ? PLATFORM_TYPE.KCP
          : PLATFORM_TYPE.LEGACY;
      const homePath = await fetchRepresentManualPath(
        manualType,
        targetPlatformType,
      );
      navigate(
        homePath ??
          (manualType === "g" && platformType === "kcp"
            ? "/g/kcp/no-index"
            : `/${manualType}/no-index`),
        { replace: true },
      );
    };
    redirectHome();
  }, [requestFailed, name, manualType, platformType, navigate]);

  if (requestFailed && name !== "no-index") {
    return null;
  }
  if (pageData === initialOptions && !requestFailed)
    if (name !== "no-index")
      return (
        <div className="manual-home">
          <div className="manual-container">
            <div className="manual-page-content">
              <section className="manual-content"></section>
            </div>
          </div>
        </div>
      );
  return (
    <>
      <ManualViewPage
        pageData={pageData}
        shortCutData={shortCutData}
        hash={hash}
        compare={false}
      />
    </>
  );
}

export default ManualPage;
